import styled, { css } from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const tableCellStyles = css`
  & th,
  & td {
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: 8px 10px;
    text-align: left;
    vertical-align: top;
  }

  & th {
    background: ${({ theme }) => theme.colors.background.light};
    font-weight: 600;
  }
`;

const variantMap = {
  normal: 'body1-normal',
  bold: 'body1-bold',
  'small-normal': 'body2-normal',
  'small-bold': 'body2-bold',
  tiny: 'body3-normal',
} as const;

export const MarkdownRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & p {
    margin: 0;
  }

  & s {
    color: ${({ theme }) => theme.colors.primaryText};
    text-decoration: line-through !important;
  }

  & ul,
  & ol {
    margin: 0;
    padding-left: 18px;
    color: ${({ theme }) => theme.colors.primaryText};
  }

  & a {
    color: ${({ theme }) => theme.colors.teal};
    text-decoration: underline;
  }

  & a:hover {
    opacity: 0.9;
  }
`;

export const MarkdownList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: ${({ theme }) => theme.colors.primaryText};

  & li::marker {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;

export const MarkdownOrderedList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: ${({ theme }) => theme.colors.primaryText};

  & li::marker {
    color: ${({ theme }) => theme.colors.primaryText};
  }
`;

export const MarkdownListItem = styled.li`
  color: ${({ theme }) => theme.colors.primaryText};

  &::marker {
    color: ${({ theme }) => theme.colors.primaryText};
  }

  & p {
    margin: 0;
  }
`;

export const ListItemContent = styled.div<{ $variant: keyof typeof variantMap }>`
  color: ${({ theme }) => theme.colors.primaryText};
  ${({ $variant }) => getVariant({ variant: variantMap[$variant] })}
`;

export const InlineCode = styled.code`
  border-radius: 4px;
  padding: 2px 4px;
  background: ${({ theme }) => theme.colors.background.light};
  font-size: 12px;
`;

export const MarkdownTableWrapper = styled.div`
  overflow-x: auto;
  max-width: 100%;
`;

export const MarkdownTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${({ theme }) => theme.colors.primaryText};

  ${tableCellStyles}

  & p {
    margin: 0;
  }
`;
